import { render, staticRenderFns } from "./GeneFamily.vue?vue&type=template&id=76c3a9a4&scoped=true"
import script from "./GeneFamily.vue?vue&type=script&lang=js"
export * from "./GeneFamily.vue?vue&type=script&lang=js"
import style0 from "./GeneFamily.vue?vue&type=style&index=0&id=76c3a9a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c3a9a4",
  null
  
)

export default component.exports